import { Checkbox, Divider, Icon, Menu } from "semantic-ui-react";

import { useTranslation } from "react-i18next";

import { db } from "astrid-firebase";
import importSources from "astrid-firestore/src/api/imports/constants/importSources";
import setImportSourceAutoDelivery from "astrid-firestore/src/api/imports/setImportSourceAutoDelivery";
import useDocumentData from "astrid-firestore/src/hooks/useDocumentData";

import Flex from "../../../../components/Flex/Flex";

function ImportSourceAutoDelivery({ source }) {
	const ref = db.collection("integrations").doc(source);

	const [settings, loading] = useDocumentData(ref);

	const autoDelivery = !!settings?.autoDelivery;

	return (
		<Menu.Item disabled={loading} onClick={() => setImportSourceAutoDelivery(ref, !autoDelivery)}>
			<Flex>
				<Checkbox slider checked={autoDelivery} label={source} />
			</Flex>
		</Menu.Item>
	);
}

export default function ImportSourcesAutoDelivery() {
	const { t } = useTranslation();

	return (
		<>
			<Divider />

			<Menu fluid vertical text>
				<Menu.Item active>
					<Flex gap={5} justifyContent="flex-start">
						<Icon name="setting" />
						{t("autoDeliver", "Auto deliver")}
					</Flex>
				</Menu.Item>

				<Menu.Menu style={{ paddingLeft: 15, borderLeft: "1px solid var(--color-border)" }}>
					{Object.values(importSources).map((source) => (
						<ImportSourceAutoDelivery key={source} source={source} />
					))}
				</Menu.Menu>
			</Menu>
		</>
	);
}
